"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
const react_1 = __importDefault(require("react"));
const styled = __importStar(require("./styled"));
var Types;
(function (Types) {
    Types["H1"] = "h1";
    Types["H2"] = "h2";
    Types["H3"] = "h3";
    Types["H4"] = "h4";
    Types["H5"] = "h5";
    Types["H1_DISPLAY"] = "h1Display";
    Types["H1_SMALL"] = "h1Small";
    Types["EYEBROW"] = "Eyebrow";
    Types["EYEBROW_SMALL"] = "Eyebrow_small";
    Types["BLOCKQUOTE"] = "Blockquote";
    Types["META_LARGE"] = "MetaLarge";
    Types["META_SMALL"] = "MetaSmall";
    Types["INTRO_ON_IMAGE"] = "IntroOnImage";
    Types["INTRODUCTORY_TEXT"] = "IntroductoryText";
    Types["BODY_1"] = "Body1";
    Types["BODY_2"] = "Body2";
    Types["BODY_3"] = "Body3";
    Types["LABEL_ON_FORM"] = "LabelOnForm";
    Types["MOBILE_MENU_ITEM"] = "MobileMenuItem";
    Types["NAV_HEADER"] = "NavHeader";
    Types["NAV_MEGA_LVL2"] = "NavMegaLvl2";
    Types["NAV_MEGA_LVL3"] = "NavMegaLvl3";
})(Types = exports.Types || (exports.Types = {}));
const Typography = (_a) => {
    var { color, styles, type, as, children, isRTE } = _a, props = __rest(_a, ["color", "styles", "type", "as", "children", "isRTE"]);
    switch (type) {
        case Types.H1_DISPLAY:
            return (react_1.default.createElement(styled.h1Display, Object.assign({ color: color, style: styles, as: as }, props), children));
        case Types.H1_SMALL:
            return (react_1.default.createElement(styled.h1Small, Object.assign({ color: color, style: styles, as: as }, props), children));
        case Types.H1:
            return (react_1.default.createElement(styled.h1, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.H2:
            return (react_1.default.createElement(styled.h2, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.H3:
            return (react_1.default.createElement(styled.h3, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.H4:
            return (react_1.default.createElement(styled.h4, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.H5:
            return (react_1.default.createElement(styled.h5, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.EYEBROW:
            return (react_1.default.createElement(styled.Eyebrow, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.EYEBROW_SMALL:
            return (react_1.default.createElement(styled.EyebrowSmall, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.BLOCKQUOTE:
            return (react_1.default.createElement(styled.Blockquote, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.META_LARGE:
            return (react_1.default.createElement(styled.MetaLarge, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.META_SMALL:
            return (react_1.default.createElement(styled.MetaSmall, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.INTRO_ON_IMAGE:
            return (react_1.default.createElement(styled.IntroOnImage, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.INTRODUCTORY_TEXT:
            return (react_1.default.createElement(styled.IntroductoryText, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.LABEL_ON_FORM:
            return (react_1.default.createElement(styled.LabelOnForm, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.BODY_1:
            return (react_1.default.createElement(styled.Body1, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.BODY_2:
            return (react_1.default.createElement(styled.Body2, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.BODY_3:
            return (react_1.default.createElement(styled.Body3, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.MOBILE_MENU_ITEM:
            return (react_1.default.createElement(styled.MobileMenuItem, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.NAV_HEADER:
            return (react_1.default.createElement(styled.NavHeader, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.NAV_MEGA_LVL2:
            return (react_1.default.createElement(styled.NavMegaLvl2, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        case Types.NAV_MEGA_LVL3:
            return (react_1.default.createElement(styled.NavMegaLvl3, Object.assign({ isRTE: isRTE, color: color, style: styles, as: as }, props), children));
        default:
            return null;
    }
};
Typography.defaultProps = {
    type: Types.EYEBROW
};
exports.default = Typography;
